import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadLieferBedingungListStatus: 'idle',
    loadLieferBedingungListError: undefined as any,
    loadLieferBedingungListLastArgs: undefined as any,
    loadLieferBedingungStatus: 'idle',
    loadLieferBedingungError: undefined as any,
    saveLieferBedingungStatus: 'idle',
    saveLieferBedingungError: undefined as any,
    deleteLieferBedingungStatus: 'idle',
    deleteLieferBedingungError: undefined as any,

    lieferBedingungList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadLieferBedingungList = createAsyncThunk('lieferBedingungSlice/loadLieferBedingungList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().lieferBedingungSlice.loadLieferBedingungListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisliefbed/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLieferBedingungListStatus } = getState().lieferBedingungSlice
        return loadLieferBedingungListStatus !== 'pending'
    }
})

export const loadLieferBedingung = createAsyncThunk('lieferBedingungSlice/loadLieferBedingung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisliefbed/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLieferBedingungStatus } = getState().lieferBedingungSlice
        return loadLieferBedingungStatus !== 'pending'
    }
})

export const saveLieferBedingung = createAsyncThunk('lieferBedingungSlice/saveLieferBedingung', async ({ lieferBedingung }: any, { rejectWithValue }: any) => {
    let promises = []
    if (lieferBedingung?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisliefbed/${ lieferBedingung?.HDR_ID }/`,
            prepareData(lieferBedingung),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisliefbed/`,
            prepareData(lieferBedingung),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveLieferBedingungStatus } = getState().lieferBedingungSlice
        return saveLieferBedingungStatus !== 'pending'
    }
})

export const deleteLieferBedingung = createAsyncThunk('lieferBedingungSlice/deleteLieferBedingung', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisliefbed/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteLieferBedingungStatus } = getState().lieferBedingungSlice
        return deleteLieferBedingungStatus !== 'pending'
    }
})

const LieferBedingungSlice = createSlice({
    name: 'lieferBedingungSlice',
    initialState,
    reducers: {
        resetloadLieferBedingungListError: (state) => {
            state.loadLieferBedingungListError = undefined
        },
        resetloadLieferBedingung: (state) => {
            state.formItem = undefined
            state.loadLieferBedingungError = undefined
        },
        resetloadLieferBedingungError: (state) => {
            state.loadLieferBedingungError = undefined
        },
        resetsaveLieferBedingung: (state) => {
            state.formItem = undefined
            state.saveLieferBedingungError = undefined
        },
        resetsaveLieferBedingungError: (state) => {
            state.saveLieferBedingungError = undefined
        },
        resetdeleteLieferBedingungError: (state) => {
            state.deleteLieferBedingungError = undefined
        },
        removeFromLieferBedingungListById: (state, action) => {
            state.lieferBedingungList = state.lieferBedingungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromLieferBedingungListByIds: (state, action) => {
            state.lieferBedingungList = state.lieferBedingungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.lieferBedingungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadLieferBedingungListStatus = 'preloaded'
            state.loadLieferBedingungListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.lieferBedingungList = []
            state.loadLieferBedingungListStatus = 'idle'
            state.loadLieferBedingungListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadLieferBedingungList.pending, (state) => {
            state.loadLieferBedingungListStatus = 'pending'
            state.loadLieferBedingungListError = undefined
        })
        builder.addCase(loadLieferBedingungList.fulfilled, (state, action) => {
            state.loadLieferBedingungListStatus = 'idle'

            if (!action.payload) { return }

            state.loadLieferBedingungListLastArgs = action.payload.args

            {
                state.lieferBedingungList = action.payload.data

            }
        })
        builder.addCase(loadLieferBedingungList.rejected, (state, action) => {
            state.loadLieferBedingungListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLieferBedingungListError = action.error.message
            } else {
                state.loadLieferBedingungListError = action.payload
            }
        })

        builder.addCase(loadLieferBedingung.pending, (state) => {
            state.loadLieferBedingungStatus = 'pending'
            state.loadLieferBedingungError = undefined
        })
        builder.addCase(loadLieferBedingung.fulfilled, (state, action) => {
            state.loadLieferBedingungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.lieferBedingungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.lieferBedingungList.push(newItem) }
                else { state.lieferBedingungList[i] = { ...state.lieferBedingungList[i], ...newItem } }
            }
        })
        builder.addCase(loadLieferBedingung.rejected, (state, action) => {
            state.loadLieferBedingungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLieferBedingungError = action.error.message
            } else {
                state.loadLieferBedingungError = action.payload
            }
        })

        builder.addCase(saveLieferBedingung.pending, (state) => {
            state.saveLieferBedingungStatus = 'pending'
            state.saveLieferBedingungError = undefined
        })
        builder.addCase(saveLieferBedingung.fulfilled, (state, action) => {
            state.saveLieferBedingungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.lieferBedingungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.lieferBedingungList.push(newItem) }
                else { state.lieferBedingungList[i] = { ...state.lieferBedingungList[i], ...newItem } }
            }
        })
        builder.addCase(saveLieferBedingung.rejected, (state, action) => {
            state.saveLieferBedingungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveLieferBedingungError = action.error.message
            } else {
                state.saveLieferBedingungError = action.payload
            }
        })

        builder.addCase(deleteLieferBedingung.pending, (state) => {
            state.deleteLieferBedingungStatus = 'pending'
            state.deleteLieferBedingungError = undefined
        })
        builder.addCase(deleteLieferBedingung.fulfilled, (state, action) => {
            state.deleteLieferBedingungStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.lieferBedingungList = state.lieferBedingungList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.lieferBedingungList = state.lieferBedingungList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteLieferBedingung.rejected, (state, action) => {
            state.deleteLieferBedingungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteLieferBedingungError = action.error.message
            } else {
                state.deleteLieferBedingungError = action.payload
            }
        })

    }
})

export const {
    resetloadLieferBedingungListError,
    resetloadLieferBedingung,
    resetloadLieferBedingungError,
    resetsaveLieferBedingung,
    resetsaveLieferBedingungError,
    resetdeleteLieferBedingungError,
    removeFromLieferBedingungListById,
    removeFromLieferBedingungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = LieferBedingungSlice.actions
export default LieferBedingungSlice.reducer
